import { Dropdown, DropdownItem, Icons, Status } from 'plume-ui';
import { StatusColor } from 'plume-ui/dist/components/Status/Status';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFeaturePermission } from '../../../../../hooks/useFeaturePermission';
import { Permission } from '../../../../../userPermissionConfig';
import FormattedMessage from '../../../../../utils/components/FormattedMessage';
import { getMonitorChartGroups } from '../../../helpers';
import { CallBackFunction } from '../../../types';

interface CellActionsMenuProps {
  id: string;
  menuHandler: { [key: string]: CallBackFunction };
}

export const CellActionsMenu = ({
  id,
  menuHandler = {},
}: CellActionsMenuProps) => {
  const { t } = useTranslation();
  const { hasPermission } = useFeaturePermission();

  const noActionDefined = (cmd: string, id: string) => {
    console.warn('Cannot find menu handler for : ', cmd, id);
  };

  return (
    <Dropdown
      listPosition="right"
      closeOnItemClick
      button={<Icons.DotsVerticalIcon width={24} />}
    >
      <DropdownItem
        onClick={() =>
          menuHandler.edit !== undefined
            ? menuHandler.edit(id)
            : noActionDefined('edit', id)
        }
        disabled={!hasPermission(Permission.EditMonitor)}
        subtexts={
          !hasPermission(Permission.EditMonitor)
            ? [t('roleIsNotAllowed')]
            : undefined
        }
      >
        <FormattedMessage id="monitors.monitorActions.edit" />
      </DropdownItem>
      <DropdownItem
        onClick={() =>
          menuHandler.redirectToOutreachConfig !== undefined
            ? menuHandler.redirectToOutreachConfig(id)
            : noActionDefined('view_outreach_config', id)
        }
        disabled={!hasPermission(Permission.ViewOutreachConfig)}
        subtexts={
          !hasPermission(Permission.ViewOutreachConfig)
            ? [t('roleIsNotAllowed')]
            : undefined
        }
      >
        <FormattedMessage id="monitors.monitorActions.viewOutreachConfig" />
      </DropdownItem>
      <DropdownItem
        onClick={() =>
          menuHandler.viewMonitorDetails !== undefined
            ? menuHandler.viewMonitorDetails(id)
            : noActionDefined('viewDetailPage', id)
        }
        disabled={!hasPermission(Permission.ViewMonitorDetail)}
        subtexts={
          !hasPermission(Permission.ViewMonitorDetail)
            ? [t('roleIsNotAllowed')]
            : undefined
        }
      >
        <FormattedMessage id="monitors.monitorActions.viewDetailPage" />
      </DropdownItem>
      <DropdownItem
        onClick={() =>
          menuHandler.delete !== undefined
            ? menuHandler.delete(id)
            : noActionDefined('delete', id)
        }
        disabled={!hasPermission(Permission.DeleteMonitor)}
        subtexts={
          !hasPermission(Permission.DeleteMonitor)
            ? [t('roleIsNotAllowed')]
            : undefined
        }
      >
        <FormattedMessage id="monitors.monitorActions.delete" />
      </DropdownItem>
    </Dropdown>
  );
};

export const renderCustomTooltip = (data: any) => {
  const groups = getMonitorChartGroups();
  const values: {
    color: StatusColor | string;
    label: string;
    key: string;
  }[] = data.values.map((value: string, index: number) => ({
    color: groups[index].stroke,
    key: groups[index].key,
    label: value,
  }));
  return (
    <>
      <div className="CustomMonitorTooltip__name">{data.name}</div>
      {values.map((val) => (
        <div className="CustomMonitorTooltip__metric" key={val.key}>
          <Status {...val} variant="legend" />
        </div>
      ))}
    </>
  );
};
